import React from 'react'
import _ from 'lodash'
import { Table } from 'semantic-ui-react'

import SenderCell from './SenderCell'
import PaymentAndLocationCell from './PaymentCell'
import DriverCell from './DriverCell'
import OrderedAtCell from './OrderedAtCell'
import StatusActionsCell from './StatusActionsCell'

export default class ExpressRow extends React.PureComponent {
  render() {
    const { order, showEditNoteModal, showLiveTracking, readOnly, showManualAssign } = this.props

    const delivererTel = order.pending_driver || order.deliverer || 'N/A'
    const delivererName = order.deliverer_name || 'N/A'
    const courierType = order.courier_type || 'N/A'

    const orderedReceivers = _.chain(order.receivers)
      .map((receiver, key) => ({ ...receiver, key }))
      .orderBy('order_number')
      .value()

    return (
      <Table.Row>
        <SenderCell
          id={order.id}
          requestor={order.requestor}
          senderName={order.sender_name}
          senderPhone={order.sender_phone}
          receivers={orderedReceivers}
        />
        <DriverCell
          order={order}
          readOnly={readOnly}
          receivers={orderedReceivers}
          delivererTel={delivererTel}
          delivererName={delivererName}
          showManualAssign={showManualAssign}
          showLiveTracking={showLiveTracking}
        />
        <PaymentAndLocationCell order={order} showEditNoteModal={showEditNoteModal} readOnly={readOnly} />
        <OrderedAtCell
          createdAt={order.created_at}
          deliveryAt={order.delivery_eta}
          pickupAt={order.pickup_eta}
          deliveredAt={order.updated_at}
          isDelivered={order.status === 'delivered'}
        />
        <StatusActionsCell status={order.status} updatedAt={order.updated_at} order={order} readOnly={readOnly} courierType={courierType} />
      </Table.Row>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/express/components/ExpressRow.js